import { defineComponent as _defineComponent } from 'vue'
import { isUsingMediaComments } from '@@/bits/flip'
import { defineAsyncComponent } from '@@/bits/vue'
import { useExpandedPostStore } from '@@/pinia/expanded_post'
import { useMentionsStore } from '@@/pinia/mentions'
import { useCommentsStore } from '@@/pinia/surface_comments'
import { useSurfaceDraftsStore } from '@@/pinia/surface_drafts'
import { useWindowSizeStore } from '@@/pinia/window_size'
import { storeToRefs } from 'pinia'


export default /*#__PURE__*/_defineComponent({
  __name: 'GlobalMentionAutocomplete',
  setup(__props) {

const MentionAutocompleteBar = defineAsyncComponent(() => import('@@/vuecomponents/MentionAutocompleteBar.vue'))
const MentionAutocompletePopover = defineAsyncComponent(() => import('@@/vuecomponents/MentionAutocompletePopover.vue'))

const { xMentionBox } = storeToRefs(useMentionsStore())
const { isSmallerThanTabletPortrait } = storeToRefs(useWindowSizeStore())
const { expandedPostCid } = storeToRefs(useExpandedPostStore())
const { hasCommentBeingEdited } = storeToRefs(useCommentsStore())
const { activeDraftCid } = storeToRefs(useSurfaceDraftsStore())

return { __sfc: true,MentionAutocompleteBar, MentionAutocompletePopover, xMentionBox, isSmallerThanTabletPortrait, expandedPostCid, hasCommentBeingEdited, activeDraftCid, isUsingMediaComments }
}

})